import { Injectable } from "@angular/core";
import { NetworkService } from "../shared/network.service";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private networkService: NetworkService) {}

  validateLogin(req: any) {
    return this.networkService.login("api/user/login", req, null, null);
  }
  validateEmailApi(req: any) {
    return this.networkService.post("api/user/verify/email", req, null, null);
  }
  otpcreateApi(req) {
    return this.networkService.post("api/otp/create?", req, null, null);
  }

  verifyOtpApi(body: any) {
    return this.networkService.post("api/otp/verify", body, null, null);
  }

  createAccountApi(body: any) {
    return this.networkService.post("api/user/signup", body, null, null);
  }
  uploadImage(image: any) {
    const formData = new FormData();
    formData.append("file", image);
    return this.networkService.uploadImages("/api/s3upload/media-upload", formData, null, "bearer");
  }
  resetPassword(req: any) {
    return this.networkService.login("api/admin/forgotPassword", req, null, null);
  }
  forgetPassword(req: any) {
    return this.networkService.login("api/user/forgot/password", req, null, null);
  }

  getCountryApi(body: any) {
    return this.networkService.get("api/country", body, null, null);
  }
  getEducationLevelApi(body: any) {
    return this.networkService.get("api/edulevel", body, null, null);
  }

  getSchoolNameApi(body: any) {
    return this.networkService.get("api/school", body, null, null);
  }
  getHouseHoldApi(body: any) {
    return this.networkService.get("api/income", body, null, null);
  }
  getCitizenShipApi(body: any) {
    return this.networkService.get("api/citizenship", body, null, null);
  }
  getEthincityApi(body: any) {
    return this.networkService.get("api/ethnicity", body, null, null);
  }
  getActivityApi(body: any) {
    return this.networkService.get("api/etc/activity", body, null, null);
  }

  getUserProfileApi(body: any) {
    return this.networkService.get("api/users/profile", body, null, "bearer");
  }

  updateProfileApi(body: any) {
    return this.networkService.put("api/user/edit/profile", body, null, "bearer");
  }
}
